import { useLoaderData } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { apiGetMostWinsWrestlerListStats } from '../../../components/ui_components/ApiList';
import GeneralRenderingSpecificStats from '../../../components/MobileComponents/Stats/GeneralRenderingSpecificStats';


const MostWinsWrestlerMobile = () => {
    const wrestlersData = (useLoaderData() as any)?.['data'] ?? [];
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year') || 'globale';

    return (
        <GeneralRenderingSpecificStats
            apiFunctionGetStats={apiGetMostWinsWrestlerListStats}
            title="Vittorie"
            stat="wins_count"
            yearStart={year}
            wrestlerDataStart={wrestlersData}
        />
    );
};

export default MostWinsWrestlerMobile;